import { success } from '../../../../styles/colors';
import { SvgIcon } from '../SvgIcon';
import * as React from 'react';

interface IProps {
	className?: string;
	fillColor?: string;
}

export const DiscountIcon: React.FC<IProps> = ({ className = '', fillColor = '' }) => {
	return (
		<SvgIcon className={`discount-icon ${className || ''}`} height={24} width={24}>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M18 7.586l-10 10L2.414 12l10-10H18v5.586zM20 8V1a1 1 0 00-1-1h-7c-.265 0-.52.106-.707.293l-11 11a.999.999 0 000 1.414l7 7a.997.997 0 001.414 0l11-11A.997.997 0 0020 8z'
				fill={fillColor || success}
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M15 7a2 2 0 10-.001-4.001A2 2 0 0015 7m6 10h-2c-.551 0-1-.449-1-1 0-.551.449-1 1-1h4v-2h-2v-1h-2v1c-1.654 0-3 1.346-3 3s1.346 3 3 3h2c.551 0 1 .449 1 1 0 .551-.449 1-1 1h-4v2h2v1h2v-1c1.654 0 3-1.346 3-3s-1.346-3-3-3'
				fill={fillColor || success}
			/>
		</SvgIcon>
	);
};
